import '@dotlottie/player-component';

function DogAnim() {
  return (
    <div className="App">
      <dotlottie-player
        src="https://lottie.host/902ae70e-6510-4de2-a7a0-8a99371520e3/kEotiKaymH.lottie"
        autoplay
        loop
        
        // style=
      />
      
    </div>
  );
}

export default DogAnim;